<template>
  <div id="blessing" :class="{ipX: isIpx}">
    <div class="wrap" v-show="!share">
      <div class="div-wrap">
        <div class="top-img" @click="jumpPage('/')"></div>
        <div class="form">
          <select class="city" v-model="city" @change="getPlayerList(1)">
            <option value ="">全国</option>
            <option v-for="item in cityList" :value ="item" :key="item">{{item}}</option>
          </select>
          <input type="text" v-model="searchName" placeholder="请输入寿星姓名">
          <div class="search" @click="getPlayerList(1)"></div>
        </div>
        <div class="tips"></div>
        <div class="item-wrap" v-if="playerList.length > 0">
          <div class="item header" v-if="hasSignup">
            <div class="left">
              <div class="index"></div>
              <div class="img-wrap">
                <img :src="userObj.headimgurl">
              </div>
            </div>
            <div class="right">
              <span class="name">{{userObj.name}}</span>
              <div class="item-button">
                你在{{city ? city : '全国'}}的排名为第 {{userObj.rank}} 名
              </div>
              <div class="energe-wrap">
                <div class="energe">
                  <div :style="{width: getEnerge(userObj.blessing_num) + '%'}" class="hold"></div>
                </div>
                <div class="num">{{userObj.blessing_num}}</div>
              </div>
            </div>
          </div>
          <div class="item" v-for="(item, index) in playerList" :key="index">
            <div class="left">
              <div class="index" :class="{first: item.rank === 1, second: item.rank === 2, third: item.rank === 3}"><span v-if="item.rank > 3">{{item.rank}}</span></div>
              <div class="img-wrap">
                <img :src="item.wechat_info.headimgurl">
              </div>
            </div>
            <div class="right">
              <span class="name">{{item.name}}</span>
              <div class="item-button">
                编号：{{item.no}} &nbsp;&nbsp; {{getBirthday(item.birthday)}}
              </div>
              <div class="energe-wrap">
                <div class="energe">
                  <div :style="{width: getEnerge(item.blessing_num) + '%'}" class="hold"></div>
                </div>
                <div class="num">{{item.blessing_num}}</div>
                <div class="ble-wrap">
                  <div class="blessing" @click="checkBlessing(item._id.$oid, item.name, item.wechat_info.headimgurl)"></div>
                </div>
              </div>
              <!-- 点击送祝福 -->
            </div>
          </div>
        </div>
        <div style="font-size: 14px; margin-top: 10px" @click="getPlayerList(2)" v-show="needMore && playerList.length > 29">查看更多 >></div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="share-wrap" v-show="share">
      <canvas width="750" height="1206" id="canvas" style="display: none"></canvas>
      <img :src="imgSrc" class="success-img">
    </div>
    <div class="mask mask-tips" v-show="showTips" @touchmove.prevent>
      <div class="dialog-tips">
        <div class="we-all-know" @click="closeTips"></div>
      </div>
    </div>
    <div class="mask mask-form" v-if="isBlessing" @touchmove.prevent>
      <div class="dialog-form">
        <div class="title">为 {{name}} 送上你的祝福</div>
        <input type="text" class="name" placeholder="输入您的名字" v-model="blessingName">
        <div class="hot" v-show="showHot"></div>
        <textarea rows="4" v-model="blessingText"></textarea>
        <div class="change" @click="changeBlessing"></div>
        <span>或者</span>
        <span class="input">手动输入(最多支持30个字)</span>
        <div class="line"></div>
        <div class="button-wrap">
          <div class="cancel" @click="cancelDialog"></div>
          <div class="sure" @click="toBlessing"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {util} from '@/common/city.js'
export default {
  name: 'blessing',
  data () {
    return {
      isIpx: false,
      largeNum: null,
      showTips: true,
      isBlessing: false,
      share: false,
      imgSrc: '',
      city: '',
      userObj: {
        headimgurl: '',
        name: '',
        rank: '',
        blessing_num: ''
      },
      needMore: true,
      hasSignup: false,
      id: '',
      blessArr: [
        '做你想做的事，去你想去的地方，爱你想爱的人，祝你生日快乐！',
        '一年只联系两次也没关系，一次你的生日，一次我的生日，祝你生日快乐',
        '每当辛勤时，愿你步伐总是轻盈；每当风起时，愿你总能昂首屹立；每当回想今日，愿你满心欢喜，歌声传唱不歇；生日快乐，我最亲爱的朋友',
        '愿你有自持而节制的华丽，层出不穷的新鲜，愈炼愈飞的魔性，永远虔诚的天真。',
        '愿你如阳光，明媚不忧伤，活得嚣张，永不受伤。',
        '愿时光能缓，愿故人不散；愿你惦念的人能和你道晚安，愿你独闯的日子里不觉得孤单。',
        '希望你一直如少年，干净纯粹心安，看透不美好却相信美好，见过不善良却依旧善良。',
        '生日是谁，它快不快乐有什么要紧的。在这个世界上，我希望你是快乐的。',
        '嘘，听我说，这里没有高逼格的生贺，只有满满的心意。 忘记啥时候认识你的，只记得今天是你的生日，一定要祝你生日快乐。',
        '但愿你的眼睛，只看得到笑容。但愿你流下每一滴泪，都让人感动。但愿你以后每一个梦，不会一场空。生日快乐。',
        '今天给你的耳朵吃颗糖吧。生日快乐！',
        '在和世界交手的这许多年，你是否依然光彩依旧，兴致盎然。祝你生日快乐！',
        '祝你以后：用神仙水拍小腿，用个海蓝之谜当护手霜，用爱马仕做垃圾袋，买几栋别墅，一栋衣帽间，一栋猫狗双全，每天纸醉金迷。生日快乐！',
        '但愿这漫长渺小人生不负你每个光辉时分',
        '感谢这么完美的我出现在你的生命里！小傻瓜，生日快乐~',
        '斯人若彩虹，遇上方知有。生日快乐！',
        '感恩我们新郎未选，伴郎已定的友谊。生日快乐！',
        '时刻记住你是被爱着的那一个。生日快乐！',
        '想把所有祝福给你，把所有欢喜赠你。生日快乐！',
        '一想到xx年前的x月x日有一个人来到这世上，我的嘴角就止不住地上扬。生快！',
        '愿你在成为井井有条的大人前，拥有许多开心得一塌糊涂的回忆。',
        '我愿做你的另一个大脑，永远在服务区。生日快乐',
        '因为我最爱的人今天才出现在世界上的，所以这是我的节日。',
        '愿你贪吃不胖，愿你深情不负，愿你傻人傻福，愿你一直幸运。愿你一生努力，一生被爱，想要的都拥有，得不到的都释怀。生日快乐，少女。',
        '愿你以后，有酒有肉有姑娘，能贫能逗能干架，此生纵情豁达。 有得有失有坚持，能哭能笑能尽欢，此生豪情逸致。生日快乐，兄弟。'
      ],
      isWechat: false,
      curBlessing: 0,
      blessingText: '每当辛勤时，愿你步伐总是轻盈；每当风起时，愿你总能昂首屹立；每当回想今日，愿你满心欢喜，歌声传唱不歇；生日快乐，我最亲爱的朋友',
      searchName: '',
      // 生日者姓名
      name: '',
      // 祝福者姓名
      blessingName: '',
      blessingAvatar: this.$store.state.userInfo.headimgurl,
      avatar: '',
      playerList: [],
      schoolList: [],
      cityList: [],
      searchInfo: {
        activity_id: 'DABjRCuSu9nKHWtlfolir01EdDWQ4veM',
        orderBy: 'rank',
        needRank: true,
        limit: 30
      },
      blessingInfo: {
        activity_id: 'DABjRCuSu9nKHWtlfolir01EdDWQ4veM',
        relation_id: '',
        relation_name: 'blessing',
        relation_content: {
          name: '',
          content: '',
          wechat_info: {
            wechat_openid: ''
          }
        }
      },
      lastBlessing: null
    }
  },
  computed: {
    showHot () {
      if (this.curBlessing === 10 || this.curBlessing === 16 || this.curBlessing === 19 || this.curBlessing === 21 || this.curBlessing === 22) {
        return true
      }
      return false
    }
  },
  methods: {
    jumpPage (path) {
      this.$router.push({path: path})
    },
    checkBlessing (id, name, src) {
      if (!this.$store.state.userInfo.openid) {
        this.$toast('请在微信中打开')
        return false
      }
      this.id = id
      this.name = name
      this.avatar = src
      let postData = {
        activity_id: 'DABjRCuSu9nKHWtlfolir01EdDWQ4veM',
        relationName: 'blessing',
        searchCond: {
          relation_id: this.id,
          wechat_openid: this.$store.state.userInfo.openid,
          headimgurl: this.$store.state.userInfo.headimgurl
        },
        orderBy: 'rank',
        needRank: true
      }
      let postUrl = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com/himo_activity/search_relation'
      this.$axios.post(postUrl, postData).then(res => {
        let len = res.data.msg.length
        if (len) {
          this.lastBlessing = res.data.msg[len - 1]
          let today = new Date(new Date().toLocaleDateString()).getTime() / 1000
          if (res.data.msg[len - 1].created_at < today) {
            this.toBlessing(1)
          } else {
            this.$toast('每人仅可祝福一次')
          }
        }
        if (!len) {
          this.isBlessing = true
        }
      })
    },
    getBirthday (time) {
      if (time) {
        return time.split('年')[1]
      }
    },
    // 投票
    toBlessing (val) {
      if (+val !== 1) {
        if (!this.blessingText || !this.blessingName) {
          this.$toast('请填写完整')
          return false
        }
        if (this.blessingText > 30) {
          this.$toast('生日祝福最多支持30个字')
          return false
        }
      } else {
        this.blessingName = this.lastBlessing.name
        this.blessingText = this.lastBlessing.content
      }
      let sexNum = this.$store.state.userInfo.sex
      let sexStr = ''
      if (+sexNum === 1) {
        sexStr = '男'
      } else if (+sexNum === 2) {
        sexStr = '女'
      } else {
        sexStr = '未知'
      }
      let postData = {
        activity_id: 'DABjRCuSu9nKHWtlfolir01EdDWQ4veM',
        relation_id: this.id,
        relation_name: 'blessing',
        relation_content: {
          name: this.blessingName,
          sex: sexStr,
          content: this.blessingText,
          wechat_info: {
            wechat_openid: this.$store.state.userInfo.openid,
            headimgurl: this.$store.state.userInfo.headimgurl
          }
        }
      }
      let postUrl = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com/himo_activity/add_relation_item'
      this.$axios.post(postUrl, postData).then(res => {
        if (res.data.success) {
          this.$toast('送祝福成功，长按页面可分享给朋友或保存图片')
          this.avatar = res.data.msg.belongs_item.wechat_info.headimgurl
          this.share = true
          this.isBlessing = false
          this.drawImage()
        } else {
          this.$toast('数据异常')
        }
      }).catch(err => {
        if (!err.response.data.success) {
          this.$toast('每人仅可祝福一次')
          return false
        }
      })
    },
    // 计算长度
    getEnerge (num) {
      if (!num) {
        return 0
      }
      return ((num / this.largeNum) * 90).toFixed(1)
    },
    closeTips () {
      this.showTips = false
    },
    watchScroll (e) {
      e.preventDefault()
    },
    changeBlessing () {
      this.curBlessing = Math.floor(Math.random() * 25)
      this.blessingText = this.blessArr[this.curBlessing]
    },
    getPlayerList (val) {
      let postUrl = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com/himo_activity/search'
      let postData = JSON.parse(JSON.stringify(this.searchInfo))
      let dataLen = this.playerList.length
      if (val === 1) {
        let search = {}
        if (this.searchName) {
          search.name = this.searchName
        }
        if (this.city) {
          search.city = this.city
        }
        if (this.searchName || this.city) {
          postData.searchCond = search
          if (this.city) {
            postData.rankCond = {
              city: this.city
            }
          }
        }
      }
      if (val === 2) {
        postData.skip = dataLen
      }
      this.$indicator.open()
      this.$axios.post(postUrl, postData).then(res => {
        this.$indicator.close()
        if (!val) {
          this.largeNum = res.data.msg[0].blessing_num
          this.playerList = res.data.msg
        }
        if (val === 1) {
          // this.needMore = false
          this.playerList = res.data.msg
          if (res.data.msg.length > 0) {
            this.largeNum = res.data.msg[0].blessing_num
          } else {
            this.$toast('该城市暂无寿星，返回首页-参与空投报名即可上榜哦')
          }
        }
        if (val === 2) {
          for (let i = 0, len = res.data.msg.length; i < len; i++) {
            this.playerList.push(res.data.msg[i])
          }
          if (!res.data.msg.length) {
            this.needMore = false
          }
        }
        this.userObj = {}
        this.hasSignup = false
        if (this.$store.state.userInfo.openid) {
          this.getMyself(3)
        }
      })
    },
    getMyself () {
      let postUrl = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com/himo_activity/search'
      let postData = JSON.parse(JSON.stringify(this.searchInfo))
      let search = {}
      if (this.city) {
        search.city = this.city
        postData.rankCond = {
          city: this.city
        }
      }
      search.open_id = this.$store.state.userInfo.openid
      postData.searchCond = search
      this.$axios.post(postUrl, postData).then(res => {
        let obj = res.data.msg[0]
        if (obj) {
          this.userObj.headimgurl = obj.wechat_info.headimgurl
          this.userObj.name = obj.name
          this.userObj.rank = obj.rank
          this.userObj.blessing_num = obj.blessing_num
          this.hasSignup = true
        }
      }).catch((err) => {
        alert(err)
      })
    },
    drawImage () {
      let canvas = document.getElementById('canvas')
      let ctx = canvas.getContext('2d')
      let img = new Image()
      let avatar = new Image()
      let border = new Image()
      let blessingAvatar = new Image()
      avatar.setAttribute('crossOrigin', 'anonymous')
      blessingAvatar.setAttribute('crossOrigin', 'anonymous')
      img.onload = (res) => {
        ctx.font = '30px Arial'
        ctx.drawImage(img, 0, 0, 750, 1206)
        avatar.onload = () => {
          // 生日人加载完成
          ctx.drawImage(avatar, 370, 311, 205, 205)
          // 祝福者加载完成
          blessingAvatar.onload = () => {
            ctx.drawImage(blessingAvatar, 151, 280, 188, 188)
            border.onload = (res) => {
              ctx.drawImage(border, 140, 220, 462, 396)
              // 写名字，写文字！
              ctx.font = '30px Arial'
              ctx.textAlign = 'center'
              ctx.fillStyle = '#083760'
              ctx.fillText(this.blessingName, 235, 470)
              ctx.fillText(this.name, 490, 318)
              ctx.font = '30px Arial'
              if (this.blessingText.length < 18) {
                ctx.fillText(this.blessingText, 380, 745)
                this.imgSrc = canvas.toDataURL('image/png', 1)
              } else if (this.blessingText.length < 35) {
                let firstPrams = ''
                let secondPrams = ''
                let len = this.blessingText.length
                for (let i = 0; i < len; i++) {
                  if (i < 17) {
                    firstPrams += this.blessingText[i]
                  } else {
                    secondPrams += this.blessingText[i]
                  }
                }
                ctx.fillText(firstPrams, 380, 715)
                ctx.fillText(secondPrams, 380, 775)
                this.imgSrc = canvas.toDataURL('image/png', 1)
              } else if (this.blessingText.length < 53) {
                let firstPrams = ''
                let secondPrams = ''
                let thirdPrams = ''
                let len = this.blessingText.length
                for (let i = 0; i < len; i++) {
                  if (i < 17) {
                    firstPrams += this.blessingText[i]
                  } else if (i < 34) {
                    secondPrams += this.blessingText[i]
                  } else {
                    thirdPrams += this.blessingText[i]
                  }
                }
                ctx.fillText(firstPrams, 380, 690)
                ctx.fillText(secondPrams, 380, 740)
                ctx.fillText(thirdPrams, 380, 790)
                this.imgSrc = canvas.toDataURL('image/png', 1)
              } else {
                let firstPrams = ''
                let secondPrams = ''
                let thirdPrams = ''
                let fourthPrams = ''
                let len = this.blessingText.length
                for (let i = 0; i < len; i++) {
                  if (i < 17) {
                    firstPrams += this.blessingText[i]
                  } else if (i < 34) {
                    secondPrams += this.blessingText[i]
                  } else if (i < 51) {
                    thirdPrams += this.blessingText[i]
                  } else {
                    fourthPrams += this.blessingText[i]
                  }
                }
                ctx.fillText(firstPrams, 380, 670)
                ctx.fillText(secondPrams, 380, 720)
                ctx.fillText(thirdPrams, 380, 770)
                ctx.fillText(fourthPrams, 380, 820)
                this.imgSrc = canvas.toDataURL('image/png', 1)
              }
            }
            // 边框问题
            border.src = require('@/assets/happyBirthday/avatar-border.png')
          }
          // 祝福者头像
          blessingAvatar.src = this.$store.state.userInfo.headimgurl.replace(/http/, 'https')
          // blessingAvatar.src = 'http://spage.haimati.cn/activityImage/birthday.png'
        }
        // 生日人头像
        avatar.src = this.avatar.replace(/http/, 'https')
        // avatar.src = 'http://spage.haimati.cn/activityImage/birthday.png'
      }
      img.src = require('@/assets/happyBirthday/share-bg.png')
    },
    cancelDialog () {
      this.blessingName = ''
      this.blessingText = this.blessArr[this.curBlessing]
      this.isBlessing = false
    },
    sureBlessing () {
      this.isBlessing = false
      this.share = true
      // 发送请求，获取用户数据
    }
  },
  mounted () {
    this.showTips = true
    let openid = this.$store.state.userInfo.openid
    if (openid) {
      this.isWechat = true
    }
    this.getPlayerList(1)
  },
  created () {
    this.cityList = util.city
    this.schoolList = util.school
  }
}
</script>
<style lang="less">
.wrap {
  // min-height: 26.7rem;
  background-image: url('~@/assets/happyBirthday/blessing-bg.png');
  background-size: contain;
  background-repeat: no-repeat;
  font-size: .3rem;
  .div-wrap {
    padding-left: .37rem;
    padding-right: .37rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
    .top-img {
      margin-top: .2rem;
      background-image: url('~@/assets/happyBirthday/blessing-top.png');
      background-size: 100% 100%;
      background-position: 0 0;
      width: 8.67rem;
      height: 5.15rem;
      margin-bottom: .3rem;
    }
    .form {
      display: flex;
      width: 100%;
      flex-flow: row nowrap;
      position: relative;
      justify-content: space-between;
      select {
        height: .85rem;
        width: 2rem;
        padding-left: .2rem;
        border: 2px solid #083760;
        outline: none;
        border-radius: .2rem;
        letter-spacing: 1px;
        margin-left: .3rem;
        font-size: .4rem;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
      }
      input {
        height: .85rem;
        width: 4.5rem;
        font-size: .4rem;
        line-height: .6rem;
        padding-left: 10px;
        border-radius: .2rem;
        border: 2px solid #083760;
        outline: none;
        letter-spacing: 1px;
      }
      .search {
        background-image: url('~@/assets/happyBirthday/search.png');
        background-size: 100% 100%;
        background-position: 0 0;
        margin-left: .1rem;
        width: 2.2rem;
        height: .85rem;
      }
    }
    .form::after {
      display: inline-block;
      position: absolute;
      content: ' ';
      background-image: url('~@/assets/happyBirthday/triangle.png');
      background-size: 100% 100%;
      width: .37rem /* 28/75 */;
      height: .32rem /* 24/75 */;
      left: 1.73rem /* 10/75 */;
      top: .27rem;
    }
    .tips {
      width: 8.08rem /* 606/75 */;
      height: 2.56rem /* 192/75 */;
      background-image: url('~@/assets/happyBirthday/tips.png');
      background-size: 100% 100%;
      background-position: 0 0;
      margin-top: 1.22rem;
      margin-bottom: .6rem;
    }
    .item-wrap {
      width: 100%;
    }
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: .3rem;
      .left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 2rem;
        img {
          width: 1.3rem;
          height: 1.3rem;
          border-radius: .1rem;
        }
        .index {
          font-size: .4rem;
          width: 1rem;
          text-align: center;
          margin-left: -.2rem;
        }
        .first {
          background-image: url('~@/assets/happyBirthday/1.png');
          width: .5rem /* 30/75 */;
          height: .67rem /* 58/75 */;
          background-size: 70% 100%;
          background-repeat: no-repeat;
          background-position-x: .1rem;
        }
        .second {
          background-image: url('~@/assets/happyBirthday/2.png');
          width: .6rem /* 36/75 */;
          height: .7rem /* 56/75 */;
          background-size: 80% 100%;
          margin-right: .1rem;
          background-repeat: no-repeat;
          background-position-x: .1rem;
        }
        .third {
          background-image: url('~@/assets/happyBirthday/3.png');
          width: .7rem;
          height: .67rem;
          background-size: 80% 100%;
          background-repeat: no-repeat;
          background-position-x: .1rem;
          margin-right: .1rem;
        }
      }
      .right {
        width: 7rem;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        .item-top {
          display: flex;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: center;
          .name {
            font-size: .38rem;
            width: 1.7rem;
            font-weight: 500;
          }
        }
      }
      .item-button {
        font-size: 12px;
      }
    }
    .energe-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: .4rem;
      .energe {
        width: 4.6rem;
        height: .36rem;
        background-color: #fff;
        border-radius: .18rem;
        border: 2px solid #083760;
        .hold {
          height: 100%;
          background-color: #ea4468;
          border-radius: .18rem;
        }
      }
      .num {
        width: .8rem;
        text-align: center;
        margin-left: .1rem;
        margin-right: .1rem;
      }
      .ble-wrap {
        width: 1.33rem;
        height: .72rem;
        .blessing {
          width: 1.33rem;
          height: .72rem;
          background-image: url('~@/assets/happyBirthday/toBlessing.png');
          background-size: 100% 100%;
          background-position: 0 0;
          margin-top: -.15rem;
          margin-left: .1rem;
        }
        .blessing:active {
          width: 1.25rem;
          height: .65rem;
        }
      }
    }
    .logo {
      width: 6.53rem;
      height: 1.01rem;
      margin: .5rem auto;
      background-image: url('~@/assets/happyBirthday/logo.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-tips {
    background-image: url('~@/assets/happyBirthday/dialog-tips.png');
    width: 8.64rem;
    height: 11.28rem;
    background-size: 100% 100%;
    z-index: 998;
    .we-all-know {
      background-image: url('~@/assets/happyBirthday/weallknow.png');
      width: 2.29rem;
      height: .83rem;
      background-size: 100% 100%;
      margin: 9.8rem auto 0;
    }
  }

  .dialog-form {
    width: 8.64rem;
    // height: 11.28rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    // background-color: #fff;
    border-radius: .4rem;
    // border: 2px solid #083760;
    background-image: url('~@/assets/happyBirthday/dialog-form.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .title {
      margin-top: .4rem;
      font-size: .45rem;
    }
    input {
      width: 6.53rem;
      height: .83rem;
      border-radius: .4rem;
      outline: none;
      border: 2px solid #083760;
      margin-top: .2rem;
      padding-left: .3rem;
      font-size: .4rem;
    }
    textarea {
      width: 6.53rem;
      height: 4.5rem;
      border-radius: .4rem;
      outline: none;
      padding: .3rem;
      font-size: .4rem;
      border: 2px solid #083760;
      margin-top: .2rem;
    }
    .change {
      background-image: url('~@/assets/happyBirthday/change.png');
      width: 2.29rem;
      height: .83rem;
      background-size: 100% 100%;
      margin-top: .4rem;
    }
    span {
      font-size: .3rem;
      margin-top: .1rem;
      font-weight: 400;
    }
    .input {
      font-size: .35rem;
      font-weight: 500;
    }
    .line {
      width: 6.53rem;
      border: 1px solid #083760;
      margin-top: .3rem;
    }
    .button-wrap {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      margin-top: .4rem;
      margin-bottom: .4rem;
      .cancel {
        background-image: url('~@/assets/happyBirthday/cancel.png');
        width: 2.29rem;
        height: .83rem;
        background-size: 100% 100%;
      }
      .sure {
        background-image: url('~@/assets/happyBirthday/sure.png');
        width: 2.29rem;
        height: .83rem;
        background-size: 100% 100%;
        margin-left: .5rem;
      }
    }
  }
  .share-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #fff;
    img {
      width: 9rem;
    }
  }
  .img-wrap {
    background-image: url('~@/assets/happyBirthday/img-wrap.png');
    background-size: 100% 100%;
    width: 1.4rem;
    height: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .header .img-wrap {
    box-sizing: border-box;
    width: 1.8rem;
    position: relative;
  }
  .header .img-wrap::after {
    content: ' ';
    display: inline-block;
    width: .85rem /* 64/75 */;
    height: .99rem /* 74/75 */;
    background-image: url('~@/assets/happyBirthday/hat.png');
    position: absolute;
    background-size: 100% 100%;
    left: -.4rem;
    top: -.55rem;
  }
  span.name {
    font-size: .43rem;
  }
  .hot {
    width: 1.63rem /* 122/75 */;
    height: .35rem /* 26/75 */;
    background-image: url('~@/assets/happyBirthday/hot.png');
    background-size: 100% 100%;
    margin-top: .4rem;
    align-self: flex-start;
    margin-left: 1.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/happyBirthday/blessing.vue